import React, {useEffect, useState} from "react";
import logo from '../assets/images/logo.png';
import fbicon from '../assets/images/home/fb.svg';
import twiitericon from '../assets/images/home/twitter.svg';
import instaicon from '../assets/images/home/insta.svg';
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { faBars, faXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Drawer, List, ListItem, ListItemText, Button } from '@mui/material';

const Header = () => {
  const navigate = useNavigate();
  const location = useLocation();
const [sticky, setSticky] = useState("");
const [open, setOpen] = useState(false);
const goToAboutSection = (name) => {
    navigate("/#"+name);
  };
  const toggleDrawer = (state) => {
    setOpen(state);
  };
  const classes = `main-header ${sticky} mobhide`;
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth" // remove if you want instant jump
    });
  }, [location.pathname]); // triggers whenever the path changes
  useEffect(() => {
        // fetchcourses();
        const handleScroll = () => {
         // sticky header
    
         const scrollTop = window.scrollY;
        const stickyClass = scrollTop >= 300 ? "is-sticky" : "";
        setSticky(stickyClass);
        console.log(stickyClass);
       };
    
        window.addEventListener("scroll", handleScroll);
        return () => {
          window.removeEventListener("scroll", handleScroll);
        };
    
      }, []);
    return (
      <section>
      <div className={classes} >
        <div className="container">
          <div className="header-row">
            <div className="logo-div">
              <img src={logo} className="logo-img" />
            </div>
            <div className="header-navbar">
              <nav className="navbar navbar-expand-lg  custom-nav ">
                <ul class="navbar-nav">
                  <li className={"nav-item"}>
                    <p onClick={() => {goToAboutSection("Home")}}>Home</p>
                  </li>
                  <li className={"nav-item"}>
                    <p onClick={() => {goToAboutSection("About")}}>About</p>
                  </li>
                  <li className={"nav-item"}>
                    <p onClick={() => {goToAboutSection("Features")}}>Features</p>
                  </li>
                  <li className={"nav-item"}>
                    <p onClick={() => {goToAboutSection("Howitworks")}}>How it works</p>
                  </li>
                  <li className={"nav-item"}>
                    <p onClick={() => {goToAboutSection("Benefits")}}>Benefits</p>
                  </li>
                  <li className={"nav-item"}>
                    <p onClick={() => {goToAboutSection("Testimonials")}}>Testimonials</p>
                  </li>
                  <li className={"nav-item"}>
                    <p onClick={() => {goToAboutSection("FAQS")}}>FAQS</p>
                  </li>
                </ul>
              </nav>
            </div>
            <div className="header-right-row">
                <Link className="header-fb-icon" to={"https://www.facebook.com/profile.php?id=61579143035601"} target="_blank">
                    <img src={fbicon} className="fbicon" />
                </Link>
                <Link className="header-fb-icon" to={"https://x.com/team_mansthal"} target="_blank">
                    <img src={twiitericon} className="fbicon" />
                </Link>
                <Link className="header-fb-icon" to={"https://www.instagram.com/team.mansthal/"} target="_blank">
                    <img src={instaicon} className="fbicon" />
                </Link>
                {/* <p className="header-border">|</p> */}

            </div>
          </div>
        </div>
      </div>
      {/* Mobile Menu */}
      <div className="deskhide">
          <div className="mobilemaindiv">
            <div
              className="mobilemenudiv"
              onClick={() => {
                setOpen(true);
              }}
            >
              <FontAwesomeIcon icon={faBars} className="menubaricon" />
            </div>
            <img src={logo} alt="Logo" className="website-logo-m" />
          </div>
          <div className="navbarheight" />
          <Drawer
            anchor="left"
            open={open}
            onClose={() => {
              toggleDrawer(false);
            }}
          >
            <List sx={{ width: 280 }}>
              <div className="mobilemenusidebarmaindiv">
                <div
                  className="mobilemenusidebar-closediv"
                  onClick={() => {
                    toggleDrawer(false);
                  }}
                >
                  <FontAwesomeIcon
                    icon={faXmark}
                    className="menubariconsidebar"
                  />
                </div>
                <div className="sidebarmain">
                <nav className="navbar navbar-expand-lg  custom-nav ">
                <ul class="navbar-nav">
                  <li className={"nav-item"}>
                    <p onClick={() => {goToAboutSection("Home")}}>Home</p>
                  </li>
                  <li className={"nav-item"}>
                    <p onClick={() => {goToAboutSection("About")}}>About</p>
                  </li>
                  <li className={"nav-item"}>
                    <p onClick={() => {goToAboutSection("Features")}}>Features</p>
                  </li>
                  <li className={"nav-item"}>
                    <p onClick={() => {goToAboutSection("Howitworks")}}>How it works</p>
                  </li>
                  <li className={"nav-item"}>
                    <p onClick={() => {goToAboutSection("Benefits")}}>Benefits</p>
                  </li>
                  <li className={"nav-item"}>
                    <p onClick={() => {goToAboutSection("Testimonials")}}>Testimonials</p>
                  </li>
                  <li className={"nav-item"}>
                    <p onClick={() => {goToAboutSection("FAQS")}}>FAQS</p>
                  </li>
                </ul>
              </nav>
                </div>
              </div>
            </List>
          </Drawer>
        </div>
      </section>
    );
}

export default Header;